export function getReactUFOPayloadVersion(interactionType) {
  if (interactionType !== 'page_load' && interactionType !== 'transition') {
    return '1.0.1';
  }
  return '2.0.0';
}